import BasePlugin from "../base/BasePlugin";
import CrossAppStore from "data/CrossAppStore";
import StereotypesStore from "data/StereotypesStore";
import SearchFormStore from "data/SearchFormStore";

export default class CrossAppPlugin extends BasePlugin {
    initialize(options) {
        super.initialize(options);

        const searchStereotypes = options.mapping.searchStereotypes.map( it => ({
                stereotypeKey: it.searchStereotypeKey,
                name: this.getStereotypeName(it.searchStereotypeKey),
                implementingEntityKey: it.implementingEntityKey
            })
        );

        this.set("name", "Cross App");
        this.set("id", "cross-app");
        this.set("fluxContext", "CTX_MappingPlugin_CrossApp");
        this.set("searchStereotypes", searchStereotypes);
        this.set("selectedStereotype", searchStereotypes[0]);
        this.set("fields", this.getFields(searchStereotypes[0].stereotypeKey));
    }

    selectStereotype(stereotypeKey) {
        this.set("selectedStereotype", this.getSearchStereotype(stereotypeKey));
        this.set("fields", this.getFields(stereotypeKey));
        this.loadFields();
    }

    hasPaginationParams() {
        return true;
    }

    getPagination(query) {
        return CrossAppStore.getPagination(query);
    }

    getQueryLO(query, params, initiate, interactive) {
        return initiate
            ? CrossAppStore.getHotLO(query, params, this.get("selectedStereotype").stereotypeKey, this.get("selectedStereotype").implementingEntityKey, interactive)
            : CrossAppStore.getColdLO(query, this.get("selectedStereotype").implementingEntityKey);
    }

    getButtonListingPrefix() {
        return `Map From Cross-App Datasource`;
    }

    getFields(stereotypeKey) {
        return StereotypesStore.getStereotypeFieldsByKey(stereotypeKey);
    }

    getStereotypeName(stereotypeKey) {
        return StereotypesStore.getStereotypeByKey(stereotypeKey).name;
    }

    searchInteractive(initiate = false) {
        const params = this.collectionSearchParams();
        return this._searchInternal(params, initiate, true);
    }

    _searchInternal(params, initiate, interactive) {
        const query = this.getAsQuery();
        return this.getQueryLO(query, params, initiate, interactive).map(this.filterRecords);
    }

    getAsQuery() {
        return SearchFormStore.getQ(this.get("fluxContext")).toAS();
    }

    getSearchStereotype(stereotypeKey) {
        return this.get("searchStereotypes").find((stereotype) => stereotype.stereotypeKey === stereotypeKey);
    }
}




// WEBPACK FOOTER //
// ./app/lib/mapping/sources/cross-app/CrossAppPlugin.js